module.exports = __webpack_public_path__ + "img/pic_default_Illustration.d058c986.png";